import React from "react";
import styled from "styled-components";

export const SDOH: React.FC = () => {
  return (
    <QuestionContainer>
      <div style={{ marginBottom: "20px" }}>
        <Question>1) Are you Hispanic or Latino?</Question>
        <Options>
          <LableWrapper>
            <Label>
              <input type="radio" /> Yes
            </Label>
            <Label>
              <input type="radio" /> No
            </Label>
            <Label>
              <input type="radio" /> choose not to answer this question
            </Label>
          </LableWrapper>
        </Options>
      </div>
      <div style={{ marginBottom: "20px" }}>
        <Question>2) Which race(s) are you? Check all that apply ?</Question>
        <Options>
          <LableWrapper>
            <Label>
              <input type="radio" /> Asian
            </Label>
            <Label>
              <input type="radio" /> Native Hawaiian
            </Label>
            <Label>
              <input type="radio" /> Pacific Islander
            </Label>
          </LableWrapper>
          <LableWrapper>
            <Label>
              <input type="radio" /> Black/African American
            </Label>
            <Label>
              <input type="radio" /> White
            </Label>
            <Label>
              <input type="radio" /> American Indian/Alaskan Native
            </Label>
          </LableWrapper>

          <LableWrapper>
            <Label>
              <input type="radio" /> I choose not to answer this question{" "}
            </Label>
            <Label>
              Other (please write) : &nbsp;
              <input
                type="text"
                style={{
                  border: "none",
                  borderBottom: "1px solid black",
                  outline: "none"
                }}
              />
            </Label>
          </LableWrapper>
        </Options>
      </div>
      <div style={{ marginBottom: "20px" }}>
        <Question>
          3) At any point in the past 2 years, has season or migrant farm work
          been your or your family’s main source of income?
        </Question>
        <Options>
          <LableWrapper>
            <Label>
              <input type="radio" /> Yes
            </Label>
            <Label>
              <input type="radio" /> No
            </Label>
            <Label>
              <input type="radio" /> choose not to answer this question
            </Label>
          </LableWrapper>
        </Options>
      </div>
      <div style={{ marginBottom: "20px" }}>
        <Question>
          4) Have you been discharged from the armed forces of the United
          States?
        </Question>
        <Options>
          <LableWrapper>
            <Label>
              <input type="radio" /> Yes
            </Label>
            <Label>
              <input type="radio" /> No
            </Label>
            <Label>
              <input type="radio" /> choose not to answer this question
            </Label>
          </LableWrapper>
        </Options>
      </div>
      <div style={{ marginBottom: "20px" }}>
        <Question>5) What language are you most comfortable speaking?</Question>
        <Label>
          Answer:&nbsp;
          <input
            type="text"
            style={{
              border: "none",
              borderBottom: "1px solid black",
              outline: "none"
            }}
          />
        </Label>
      </div>
      <h1 style={{ fontWeight: "bold", marginBottom: "20px" }}>
        Family & Home
      </h1>
      <div style={{ marginBottom: "20px" }}>
        <Question>
          6) How many family members, including yourself, do you currently live
          with?{" "}
        </Question>
        <Options>
          <LableWrapper>
            <Label>
              Answer:&nbsp;
              <input
                type="text"
                style={{
                  border: "none",
                  borderBottom: "1px solid black",
                  outline: "none"
                }}
              />
            </Label>
            <Label>
              <input type="radio" /> I choose not to answer this question
            </Label>
          </LableWrapper>
        </Options>
      </div>
      <div style={{ marginBottom: "20px" }}>
        <Question>7) What is your housing situation today? </Question>
        <Options>
          <>
            <Label>
              <input type="radio" /> I have housing
            </Label>
            <Label>
              <input type="radio" /> I do not have housing (staying with others,
              in a hotel, in a shelter, living outside on the street, on a
              beach, in a car, or in a park)
            </Label>
            <Label>
              <input type="radio" /> I choose not to answer this question
            </Label>
          </>
        </Options>
      </div>
      <div style={{ marginBottom: "20px" }}>
        <Question>8) Are you worried about losing your housing? </Question>
        <Options>
          <>
            <Label>
              <input type="radio" /> Yes
            </Label>
            <Label>
              <input type="radio" /> No
            </Label>
            <Label>
              <input type="radio" /> I choose not to answer this question
            </Label>
          </>
        </Options>
      </div>
      <div style={{ marginBottom: "20px" }}>
        <Question>9) What address do you live at? </Question>
        <Options>
          <>
            <Label>
              street:&nbsp;{" "}
              <input
                type="text"
                style={{
                  border: "none",
                  borderBottom: "1px solid black",
                  outline: "none"
                }}
              />
            </Label>
            <Label>
              City, State, Zip code: &nbsp;{" "}
              <input
                type="text"
                style={{
                  border: "none",
                  borderBottom: "1px solid black",
                  outline: "none"
                }}
              />
            </Label>
          </>
        </Options>
      </div>
      <h1 style={{ fontWeight: "bold", marginBottom: "20px" }}>
        Money & Resources{" "}
      </h1>
      <div style={{ marginBottom: "20px" }}>
        <Question>
          10) What is the highest level of school that you have finished?{" "}
        </Question>
        <Options>
          <>
            <Label>
              <input type="radio" />
              Less than high school degree
            </Label>
            <Label>
              <input type="radio" />
              High school diploma or GED
            </Label>
            <Label>
              <input type="radio" />
              More than high school
            </Label>
            <Label>
              <input type="radio" />I choose not to answer this question
            </Label>
          </>
        </Options>
      </div>
      <div style={{ marginBottom: "20px" }}>
        <Question>11) What is your current work situation? </Question>
        <Options>
          <>
            <Label>
              <input type="radio" />
              Unemployed
            </Label>
            <Label>
              <input type="radio" />
              Part-time or temporary work
            </Label>
            <Label>
              <input type="radio" />
              Full-time work
            </Label>
            <Label>
              <input type="radio" /> I choose not to answer this question{" "}
            </Label>
            <Label>
              Otherwise unemployed but not seeking work (ex: student,
              <br />
              retired, disabled, unpaid primary care giver) Please write: &nbsp;
              <input
                type="text"
                style={{
                  marginTop: "15px",
                  border: "none",
                  borderBottom: "1px solid black",
                  outline: "none"
                }}
              />
            </Label>
          </>
        </Options>
      </div>
      <div style={{ marginBottom: "20px" }}>
        <Question>12) What is your main insurance?</Question>
        <Options>
          <>
            <Label>
              <input type="radio" />
              None/uninsured
            </Label>
            <Label>
              <input type="radio" />
              Medicaid
            </Label>
            <Label>
              <input type="radio" />
              CHIP Medicaid
            </Label>
            <Label>
              <input type="radio" />
              Medicare
            </Label>

            <Label>
              <input type="radio" />
              Other public insurance (not CHIP)
            </Label>
            <Label>
              <input type="radio" />
              Other Public Insurance (CHIP)
            </Label>
            <Label>
              <input type="radio" />
              Private Insurance
            </Label>
          </>
        </Options>
      </div>
      <div style={{ marginBottom: "20px" }}>
        <Question>
          13) During the past year, what was the total combined income for you
          and the family members you live with? This information will help us
          determine if you are eligible for any benefits.
        </Question>
        <Options>
          <>
            <Label>
              Answer:&nbsp;
              <input
                type="text"
                style={{
                  border: "none",
                  borderBottom: "1px solid black",
                  outline: "none"
                }}
              />
            </Label>
            <Label>
              <input type="radio" />I choose not to answer this question
            </Label>
          </>
        </Options>
      </div>
      <div style={{ marginBottom: "20px" }}>
        <Question>
          14) In the past year, have you or any family members you live with
          been unable to get any of the following when it was really needed?
          Check all that apply.
        </Question>
        <Options>
          <>
            <Label>
              Food : &emsp;&emsp;
              <input type="radio" /> Yes &nbsp;&nbsp;
              <input type="radio" /> No
            </Label>
            <Label>
              Clothing : &nbsp;
              <input type="radio" /> Yes &nbsp;&nbsp;
              <input type="radio" /> No
            </Label>
            <Label>
              Utilities : &emsp;&nbsp;
              <input type="radio" /> Yes &nbsp;&nbsp;
              <input type="radio" /> No
            </Label>
            <Label>
              Child Care : &emsp;
              <input type="radio" /> Yes &nbsp;&nbsp;
              <input type="radio" /> No
            </Label>
            <Label>
              Medicine or Any Health Care (Medical, Dental, Mental Health,
              Vision) : &nbsp;&nbsp;
              <input type="radio" /> Yes &nbsp;&nbsp;
              <input type="radio" /> No
            </Label>
            <Label>
              Phone : &nbsp;&nbsp;
              <input type="radio" /> Yes &nbsp;&nbsp;
              <input type="radio" /> No
            </Label>

            <Label>
              <input type="radio" /> I choose not to answer this question
            </Label>

            <Label>
              Other (please write) : &nbsp;&nbsp;
              <input
                type="text"
                style={{
                  border: "none",
                  borderBottom: "1px solid black",
                  outline: "none"
                }}
              />
            </Label>
          </>
        </Options>
      </div>
      <div style={{ marginBottom: "20px" }}>
        <Question>
          15) Has lack of transportation kept you from medical appointments,
          meetings, work, or from getting things needed for daily living? Check
          all that apply
        </Question>
        <Options>
          <>
            <Label>
              <input type="radio" /> Yes, it has kept me from medical
              appointments
            </Label>
            <Label>
              <input type="radio" />
              rom Yes, it has gettingkeptmyme from medications non-medical
              meetings, appointments, work, or from getting things that I need
            </Label>
            <Label>
              <input type="radio" /> No
            </Label>
            <Label>
              <input type="radio" /> I choose not to answer this question
            </Label>
          </>
        </Options>
      </div>
      <h1 style={{ fontWeight: "bold", marginBottom: "20px" }}>
        Social and Emotional Health
      </h1>
      <div style={{ marginBottom: "20px" }}>
        <Question>
          16) How often do you see or talk to people that you care about and
          feel close to? (For example: talking to friends on the phone, visiting
          friends or family, going to church or club meetings)
        </Question>
        <Options>
          <>
            <Label>
              <input type="radio" /> Less than once a week
            </Label>
            <Label>
              <input type="radio" />1 or 2 times a week
            </Label>
            <Label>
              <input type="radio" /> 3 to 5 times a week
            </Label>
            <Label>
              <input type="radio" /> 6 or more times a week question
            </Label>
            <Label>
              <input type="radio" /> I choose not to answer this question
            </Label>
          </>
        </Options>
      </div>
      <div style={{ marginBottom: "20px" }}>
        <Question>
          17) Stress is when someone feels tense, nervous, anxious, or can’t
          sleep at night because their mind is troubled. How stressed are you?
        </Question>
        <Options>
          <>
            <Label>
              <input type="radio" /> Not at all
            </Label>
            <Label>
              <input type="radio" /> A little bit
            </Label>
            <Label>
              <input type="radio" /> Somewhat
            </Label>
            <Label>
              <input type="radio" /> Quite a bit
            </Label>
            <Label>
              <input type="radio" /> Very much
            </Label>
            <Label>
              <input type="radio" /> I choose not to answer this question
            </Label>
          </>
        </Options>
      </div>
      <h1 style={{ fontWeight: "bold", marginBottom: "20px" }}>
        Optional Additional Questions
      </h1>
      <div style={{ marginBottom: "20px" }}>
        <Question>
          18) In the past year, have you spent more than 2 nights in a row in a
          jail, prison, detention center, or juvenile correctional facility?
        </Question>
        <Options>
          <>
            <Label>
              <input type="radio" />
              Yes
            </Label>
            <Label>
              <input type="radio" /> No
            </Label>
            <Label>
              <input type="radio" /> I choose not to answer this
            </Label>
          </>
        </Options>
      </div>
      <div style={{ marginBottom: "20px" }}>
        <Question>19) Are you a refugee?</Question>
        <Options>
          <>
            <Label>
              <input type="radio" />
              Yes
            </Label>
            <Label>
              <input type="radio" /> No
            </Label>
            <Label>
              <input type="radio" /> I choose not to answer this
            </Label>
          </>
        </Options>
      </div>
      <div style={{ marginBottom: "20px" }}>
        <Question>
          20) Do you feel physically and emotionally safe where you currently
          live? ?
        </Question>
        <Options>
          <>
            <Label>
              <input type="radio" />
              Yes
            </Label>
            <Label>
              <input type="radio" /> No
            </Label>
            <Label>
              <input type="radio" /> Unsure
            </Label>
            <Label>
              <input type="radio" /> I choose not to answer this question
            </Label>
          </>
        </Options>
      </div>
      <div style={{ marginBottom: "20px" }}>
        <Question>
          21) In the past year, have you been afraid of your partner or
          ex-partner?
        </Question>
        <Options>
          <>
            <Label>
              <input type="radio" />
              Yes
            </Label>
            <Label>
              <input type="radio" /> No
            </Label>
            <Label>
              <input type="radio" /> Unsure
            </Label>
            <Label>
              <input type="radio" /> I have not had a partner in the past year
            </Label>
            <Label>
              <input type="radio" /> I choose not to answer this question
            </Label>
          </>
        </Options>
      </div>
    </QuestionContainer>
  );
};

const IntroMessage = styled.div`
  margin-bottom: 20px;
  padding: 10px;
  border: 1px solid #ccc;
  background-color: #f7f7f7;
`;

const SurveyContainer = styled.div`
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
`;

const QuestionContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  padding: 10px;
  border-bottom: 1px solid #ccc;
  margin-bottom: 10px;
`;

const Question = styled.div`
  font-weight: bold;
  margin-bottom: 5px;
`;

const Options = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  gap: 5px;
`;

const LableWrapper = styled.div`
  display: grid;
  gap: 15px;
  grid-template-columns: repeat(3, 1fr);
`;

const Label = styled.div`
  display: flex;
  align-items: center;
`;

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  gap: 10px;
`;

const SpinContainer = styled.div`
  top: 60%;
  left: 50%;
  position: absolute;
`;
